// @flow
import $ from 'jquery';
import dayjs from 'dayjs';

const rightsFormValidator = () => {
  $('.rights-form').each((_, form) => {
    $(form).validate({
      ignore: '',
      errorPlacement: (error, element) => {
        element.closest('.form-group').append(error);
      },
      rules: {
        'right[stock_type_id]': {
          required: true,
        },
        'right[quantity]': {
          required: true,
          greaterThan: 0,
        },
        'right[strike_price]': {
          required: true,
        },
        'right[releases_at]': {
          required: true,
          validDate: 'validDate',
          lessThanEqual: dayjs().add(50, 'y'),
          greaterThanEqual: dayjs().subtract(50, 'y'),
        },
        'right[expries_at]': {
          required: true,
          validDate: 'validDate',
          greaterThanEqualDateTo: $(form).find('#right_releases_at'),
          lessThanEqual: dayjs().add(50, 'y'),
          greaterThanEqual: dayjs().subtract(50, 'y'),
        },
      },
      messages: {
        'right[stock_type_id]': {
          required: '種類は必須項目です。',
        },
        'right[quantity]': {
          required: '新株予約権数は必須項目です。',
          greaterThan: '半角数字のみでご入力ください。',
        },
        'right[strike_price]': {
          required: '行使価格は必須項目です。',
        },
        'right[releases_at]': {
          required: '取得年月日は必須項目です。',
          validDate: '取得年月日の形式が正しくありません。',
          lessThanEqual: '取得年月日の形式が正しくありません。',
          greaterThanEqual: '取得年月日の形式が正しくありません。',
        },
        'right[expries_at]': {
          required: '失効期限は必須項目です。',
          validDate: '失効期限の形式が正しくありません。',
          greaterThanEqualDateTo: '失効期限の形式が正しくありません。',
          lessThanEqual: '失効期限の形式が正しくありません。',
          greaterThanEqual: '失効期限の形式が正しくありません。',
        },
      },
    });
  });
};

export default rightsFormValidator;
